import forIn from 'lodash/forIn';
import sortBy from 'lodash/sortBy';

import { PlatformDto } from '../../shared/dtos/platform.dto';
import { PlatformObject } from '../models/platforms-object.model';

export const appPlatformsAdapter = (
  arr: PlatformDto[] | undefined
): [string, string][] => {
  if (!arr) {
    return [];
  }

  const formattedPlatforms: [string, string][] = [];
  const platformObject = arr.reduce<PlatformObject>(
    (acc, item) => ({
      ...acc,
      [item.name]: acc[item.name]
        ? sortBy([...acc[item.name], +item.version])
        : [+item.version],
    }),
    {}
  );

  forIn(platformObject, (value, key) => {
    formattedPlatforms.push([key, value.join(', ')]);
  });

  return formattedPlatforms;
};
